<template>
    <div>
        <section class="main-slider" v-if="softwareInfo">
            <div class="page-header-bg" :style="{backgroundImage: softwareInfo.bannerUrl}">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1> <!-- softwareInfo.title --> {{  $t(`software.${softwareInfo.i18n_title}`) }} <span style="color: var(--bs-orange);">{{ softwareInfo.title_abb }}</span></h1> 
					<div class="page-header__inner_text" style="font-weight: bold;">{{ softwareInfo.title_en }}</div>
                    <div class="page-header__inner_text">
                        <!-- {{ softwareInfo.text }} -->
                        {{  $t(`software.${softwareInfo.i18n_text}`) }}
                    </div>
                    <div class="page-header__inner_action">
                        <a :href="softwareInfo.url" target="_blank" v-if="softwareInfo.buttonShow && softwareInfo.url">
                            <div class="page-header__inner_action_item action_item_margin  action_item-color button_hover">
                                <!-- 产品演示  -->
                                {{ $t('software.product_demo') }}
                            </div>
                        </a>
                        <div class="page-header__inner_action_item action_item_margin button_hover" @click="handleSeek()">
                            <a  >
                                <!-- 联系我们 -->
                                {{ $t('software.contact_Us') }}</a>
                        </div>
                    </div>
                </div>
                
            </div>
        </section>
      

		<section class="blog-details" v-if="softwareInfo">
            <div class="container">

                  <!-- 一张图片展示功能 -->
                <div class="row" v-if="softwareInfo.i18n_functionImgUrl">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                <!-- {{ softwareInfo.functionImgTitle }} -->
                            {{  $t(`software.${softwareInfo.i18n_functionImgTitle}`) }}
                            </h3>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12" style="text-align: center;">
                        <img class="row_img" :src="softwareInfo.i18n_functionImgUrl" />
                    </div>
                </div>
                <!-- 左右图片和描述的功能 -->
                <div class="row" v-if="softwareInfo.mainFunctionShow">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                           <h3> 
                            <!-- {{ softwareInfo.mainFunctionTitle }} -->
                             {{  $t(`software.${softwareInfo.i18n_mainFunctionTitle}`) }}
                        </h3>
                        </div>
                    </div>

                     <div class="row" v-for="(item, index) in softwareInfo.i18n_mainFunctionList" :key="index">
                        <div class="row" v-if="index%2 == 0" style="margin: 50px 0;">
                            <div class="col-xl-6 col-lg-12 wow fadeInUp" style="text-align: center;">
                                    <img class="row_img" :src="item.img" />
                            </div>
                            <div class="col-xl-6 col-lg-12 wow fadeInUp" >
                                <div class="row_align">
                                    <p class="rf_title">
                                        <!-- {{ item.title }} -->
                                        {{  $t(`software.${item.title}`) }}
                                    </p>
                                    <p class="rf_text rfc_margin">
                                        <!-- {{ item.text }} -->
                                        {{  $t(`software.${item.text}`) }}
                                    </p>
                                    <p class="rf_text rfc_margin" v-if="item.text1">
                                        <!-- {{ item.text1 }} -->
                                        {{  $t(`software.${item.text1}`) }}
                                    </p>
                                     <a :href="softwareInfo.url" target="_blank" v-if="softwareInfo.buttonShow && softwareInfo.url && index == 0">
                                        <div class="page-header__inner_action_item action_item-color button_hover rfc_button_margin">
                                            <a>
                                                <!-- 立即体验 -->
                                                {{  $t("software.try_now") }}
                                            </a>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-xl-6 col-lg-12 wow fadeInUp" >
                                <div class="row_align">
                                    <p class="rf_title">
                                        <!-- {{ item.title }} -->
                                           {{  $t(`software.${item.title}`) }}
                                    </p>
                                    <p class="rf_text rfc_margin">
                                        <!-- {{ item.text }} -->
                                        {{  $t(`software.${item.text}`) }}
                                    </p>
                                    <p class="rf_text rfc_margin" v-if="item.text1">
                                        <!-- {{ item.text1 }} -->
                                        {{  $t(`software.${item.text1}`) }}
                                    </p>
                            
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-12 wow fadeInUp" style="text-align: center;">
                                    <img class="row_img" :src="item.img" />
                            </div>

                        </div>
                    </div>

                </div>
                <!-- 功能描述 -->
				<div class="row" v-if="softwareInfo && softwareInfo.i18n_functionList.length">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                 <!-- {{ softwareInfo.functionTitle }} -->
                                {{  $t(`software.${softwareInfo.i18n_functionTitle}`) }}
                            </h3>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 20px;">
                        <div class="col-xl-4 col-lg-6 row_fli"  v-for="(item,index) in softwareInfo.i18n_functionList" :key="index">
                            <div class="row_fli_item">
                                <div class="row_fli_title">
                                    <p>
                                        <!-- {{ item.title }} -->
                                        {{  $t(`software.${item.title}`) }}
                                    </p>
                                    <div></div>
                                </div>
                                <div class="row_fli_text">
                                    <p>
                                       <!-- {{ item.text }} -->
                                        {{  $t(`software.${item.text}`) }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 小程序功能 -->
                <div class="row" v-if="softwareInfo.i18n_funtionAppletUrl">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                <!-- {{ softwareInfo.funtionAppletTitle }} -->
                                {{  $t(`software.${softwareInfo.i18n_funtionAppletTitle}`) }}
                            </h3>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12" >
                       <!-- <div class="row_img"> -->
                            <img class="row_img" :src="softwareInfo.i18n_funtionAppletUrl" />
                       <!-- </div> -->
                    </div>

                </div>
                <!-- 招聘流程 -->
                <div class="row" v-if="softwareInfo.i18n_flowPathUrl">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                <!-- {{ softwareInfo.flowPathTitle }} -->
                                {{  $t(`software.${softwareInfo.i18n_flowPathTitle}`) }}
                            </h3>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12" >
                       <!-- <div class="row_img"> -->
                            <img class="row_img" :src="softwareInfo.i18n_flowPathUrl" />
                       <!-- </div> -->
                    </div>

                </div>
                <!-- 产品价值 -->
                <div class="row" v-if="softwareInfo.valueShow" style="margin-bottom: 50px;">
					<div class="col-xl-12 col-lg-12" >
                        <div class="row__title">
                            <h3>
                                <!-- 产品价值 -->
                            {{  $t('software.product_value') }}
                            </h3>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12" >
                        <div class="row_value">
                            <div  class="row_value_list">
                                <div class="row_value_list_item row_value_img1">
                                    <img class="row_value_list_img " :src="softwareInfo.valueUrl1" alt="">
                                </div>
                                <div class="row_value_list_item row_value_img2 row_value_list_active">
                                    <img class="row_value_list_img  " :src="softwareInfo.valueUrl2" alt="">
                                </div>
                                <div class="row_value_list_item row_value_img3">
                                    <img class="row_value_list_img " :src="softwareInfo.valueUrl3" alt="">
                                </div>
                            </div>                
                            <div class="row_value_text">
                                <!-- <div class="rvt_nub" data-text="1">
                                    <div class="rvt_nub_he" data-text="0">
                                        <span class="rvt_nub_he_deco"><i></i></span>
                                        <div class="rvt_nub_title">提高生产效率</div>
                                        <div class="rvt_nub_text ">
                                            <p>无纸化管理，减少手工填写数据；通过系统优化流程，减少生产过程中的流程等待。从而提高生产效率。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="rvt_nub" data-text="2">
                                    <div class="rvt_nub_he">
                                        <span class="rvt_nub_he_deco"><i></i></span>
                                        <div class="rvt_nub_title">提高焊接质量</div>
                                        <div class="rvt_nub_text ">
                                            <p>系统对焊接全过程监控，实时记录和反馈问题，减少返工成本，优化焊接工艺，提高焊接质量。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="rvt_nub" data-text="3">
                                    <div class="rvt_nub_he">
                                        <span class="rvt_nub_he_deco"><i></i></span>
                                        <div class="rvt_nub_title">促进企业数字化转型</div>
                                        <div class="rvt_nub_text">
                                            <p>打通生产焊接环节，完善和推动企业全面数字化，提高企业竞争力，推进可持续性发展。</p>
                                        </div>
                                    </div>
                                </div>    -->
                                <div class="rvt_nub"  v-for="(item,index) in softwareInfo.i18n_valueList" :key="index" :data-text="index+1">
                                    <div class="rvt_nub_he">
                                        <span class="rvt_nub_he_deco"><i></i></span>
                                        <div class="rvt_nub_title">
                                            <!-- {{ item.title }} -->
                                            {{  $t(`software.${item.title}`) }}
                                        </div>
                                        <div class="rvt_nub_text">
                                            <p>
                                                <!-- {{ item.text  }} -->
                                                 {{  $t(`software.${item.text}`) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>                           
                            </div>
                        </div>
                       
                      
                    </div>

                </div>
			</div> 
            <!-- 对比分析 -->
            <div class="row_contrast" v-if="softwareInfo.i18n_contrastTitle" :style="{ backgroundImage: softwareInfo.contrastBgUrl}">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12" >
                            <div class="row__title">
                                <h3>
                                    <!-- {{ softwareInfo.contrastTitle }} -->
                                     {{  $t(`software.${softwareInfo.i18n_contrastTitle}`) }}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div class="row contrast_row" v-if="!softwareInfo.contrastImgShow">
                        <div class="col-xl-2 col-lg-12 contrast_item" v-for="(item,index) in softwareInfo.i18n_contrastList" :key="index">
                            <div class="contrast_item_title" style="">
                                <!-- {{ item.title }} -->
                                 {{  $t(`software.${item.title}`) }}
                            </div>
                            <div class="contrast_item_text" style=" ">
                                {{ item.text }}
                                  <!-- {{  $t(`software.${item.text}`) }} -->
                                <span style="font-size: 30px;">%</span></div>
                        </div>
                    </div>
                    <div class="row" v-if="softwareInfo.contrastImgShow">
                        <div class="col-xl-12 col-lg-12" >
                                <img class="row_img" :src="softwareInfo.i18n_contrastUrl" />
                        </div>
                    </div>
                    <div class="row_contrast_butoon">
                        <a @click="handleDetail(softwareInfo)"  v-if="softwareInfo.buttonShow && softwareInfo.url">
                            <div class="page-header__inner_action_item action_item-color rct_aglin button_hover">
                               <a>{{ $t('software.try_now') }}</a>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
		</section>
        <seek-dialog v-if="seekShow" :title="softwareInfo.title"  @close="handleClose"/>
    </div>
</template>

<script >

import SeekDialog from "@/components/seekDialog"
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'productSoftware',
    mixins: [MixinsList],
    components: {
        SeekDialog
    },
    data () {
        return {          
            softwareInfo: null,  // 信息
            seekShow: false,
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
         // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.product_li').addClass('current');

        $(".rvt_nub").mouseenter(function(e){

            // // 切换背景
             $('.row_value_list_active').removeClass('row_value_list_active'); 
            var param = 'row_value_img' + $(this).data('text')
            $('.'+param).addClass('row_value_list_active'); 
            // 展示信息
            $('.rvt_nub_action').removeClass('rvt_nub_action');  
            $(this).addClass("rvt_nub_action");
            
             
        
        }).mouseleave(function() {
        })
    },
    methods: {
      
        // 获取内容
        async getList() {
          
            // const software = res[this.lang]
            try {
            const software = await loadData('productSoftware', this.lang)

           	this.softwareInfo = software[this.$route.query.type]
             } catch (error) {
                 console.error('[productSoftware] 加载失败:', error)
                this.softwareInfo = {}
             }
          

        },
       
        // 联系我们 
        handleSeek() {
            this.seekShow = true
        },
        // 关闭
        handleClose() {
            this.seekShow = false
        },

            // 打开系统页面
        handleDetail(item) {
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = item.url
                link.target="_blank"    // 在新的tab页打开
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)   // 删除a接点
                window.URL.revokeObjectURL(item.url)   // 销毁
          
           
        },
    }
}
</script>
<style scoped>
.blog-details {
    padding: 60px 0 0px;
}
body {
	color: var(--notech-black) !important;
}
.page-header-bg {
    background-color: transparent; 
}

.page-header__inner h1{
    font-size: var(--font-size-45);
    /* width: 45%; */
    /* text-align: justify; */
    /* text-align-last: justify; */
    text-justify: distribute-all-lines;  /*兼容ie*/
 }

.page-header__inner_text{
    width: 45%;
    font-size: var(--font-size-20);
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
 }
 .page-header__inner_action {
    margin-top: 50px;
    display: flex;
 }
 .page-header__inner_action_item {
    cursor: pointer;
    text-align: center;
    color: var(--notech-white);
    border-radius: 5px;
    width: 200px;    
   
    border: 1px solid rgba(169, 183, 222, 0.86);
    padding: 10px 15px;
    background: rgba(255, 255, 255, 0.2);
    position: relative;
    transition: all 0.36s;
    
 }
 .action_item_margin {
    margin: 0 18px;
 }
 .action_item-color {
    /* background: var(--notech-base); */
    background: #3595f7;
 }
 .button_hover:hover {
    /* background: #097cf2 !important; */
    background: var(--notech-base);
}

.row__title {
    margin: 45px 0;
    text-align: center;
    font-size: var(--font-size-30);
    line-height: 50px;
    color: #232e5e;
}
.row__title h3{
    font-size: var(--font-size-30);
    line-height: 50px;
    font-weight: bold;
}
.row_img {
    max-width: 100%;
}
.row_value {
    width: 100%;
    height: 500px;
    visibility: visible;
    animation-name: ysfadeInUp0;
    animation: ysfadeInUp0 .5s ease-in-out 1 both;
    animation-delay: 0.2s;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
}
.row_value_list {
    display: flex;
    width: 100%;
    position: relative;
    display: block;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
}
.row_value_list_item {
    display: none;
    transition: opacity 500ms ease 0s;
}
.row_value_slick-list{
    width: 3426px;
    /* max-height: 500px; */
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0;
    padding: 0;
}
.row_value_list_img{
    max-width: 100%;
   
}
.row_value_list_active {
    display: block;
}

.row_value_text {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
} 
.rvt_nub{
    width: 33.333333%;
    flex-grow: 1;
    height: 100%;
    border-right: 1px solid rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
}
.rvt_nub_he {
    width: 72%;  
}
.rvt_nub_he_deco{
    margin-bottom: 12px;
    display: block;
    width: 60px;
    height: 60px;
    opacity: 1;
    transition: .1s;
    transform: translateZ(0);
    margin: 0 auto;
}
.rvt_nub_he_deco:before {
    content: "";
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) scale(.75);
    transition: .4s;
    border: 1px solid hsla(0, 0%, 100%, .3);
    border-radius: 100%;
    height: 40px;
    width: 40px;
}
.rvt_nub_he_deco i{
    background: hsla(0, 0%, 100%, .8);
    border: 1px solid #fff;
    border-radius: 100%;
    height: 22px;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) scale(.5);
    transition: .4s;
    width: 22px;
}
.rvt_nub_he_deco:after {
    content: "";
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0) scale(.75);
    transition: .4s;
    border: 1px solid hsla(0, 0%, 100%, .1);
    border-radius: 100%;
    height: 60px;
    width: 60px;
}

.rvt_nub_title {
    text-align: center;
}
@media screen and (max-width: 1449px) {
.rvt_nub_title  {
    font-size: var(--font-size-24)
}
}
@media screen and (min-width: 1500px) {
.rvt_nub_title  {
    font-size:  var(--font-size-30);
}
}
.rvt_nub_title {
    font-size: var(--font-size-30);
    line-height: 1.5;
    color: #fff;
    font-weight: bold;
}
.rvt_nub_text{
    display: none;
    height: 84px;
    padding-top: 0px;
    margin-top: 15px;
    padding-bottom: 0px;
    margin-bottom: 0px;
}
.rvt_nub_text p {
    font-size: var(--font-size-16);
    line-height: 1.75;
    color: #fff;
    text-align: center;
}
.rvt_nub_action .rvt_nub_text {
    display: block;
    height: 63px;
    padding-top: 0px;
    margin-top: 15px;
    padding-bottom: 0px;
    margin-bottom: 0px;
}
.row_contrast {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin-top: 50px;
    padding-bottom: 50px;
    width: 100%;
    /* height: 400px; */
}
.row_contrast_butoon {
    margin-top: 40px;
}

.row_align {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content:center;
}
.rct_aglin {
    margin: 0 auto;
}
/* 产品功能-具体介绍 */
.rf_title {
    line-height: 40px;
    margin-top: 10px;
    font-size: var(--font-size-24);
    font-weight: bold;
}
.rfc_margin {
    margin-top: 20px;
}
.rfc_button_margin {
    margin-top: 35px;
}
.rf_text {
    /* overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical; */

    line-height: 30px;
    font-size: var(--font-size-16);
    font-weight: bold;
}


.row_fli {
 padding: 15px;
}
.row_fli_item {
    box-shadow: 0 0 10px 3px rgba(19, 55, 159, .08);
    padding: 20px 30px 20px;
}
.row_fli_title p{
    font-size: var(--font-size-20);
    line-height: 50px;
    font-weight: bold;
}
.row_fli_title div {
    /* margin-top: 10px; */
    width: 40px;
    height: 3px;
    border-radius: 1px;
    background: var(--notech-base);
}
.row_fli_text {
    height: 80px;
    margin-top: 15px;
}
.row_fli_text p{
    color: #666666;
   font-size: 14px;
   font-weight: bold;
   line-height: 1.2;
}


.contrast_row {
    background-color: #fff;  
    box-shadow: 0 0 10px 3px rgba(19, 55, 159, .08); 
    padding: 50px 0; 
    display: flex;     
    justify-content: space-around;
}
.contrast_item {
    /* width: 15%;  */
    text-align: center;
    margin: 20px 0;
}
.contrast_item_title {
    font-size: 18px; 
    font-weight: 600; 
    margin-bottom: 30px;
}
.contrast_item_text {
    font-size: 60px;
    color: var(--notech-base); 
    font-weight: 700;
}
</style> 
